import ConciergeLandingPage from '../../components/Products/RoleModelAI/ConciergeLandingPage';

export default function RoleModelAIPage() {
  return <ConciergeLandingPage />;
}
